import React from 'react'

// Lazy load heavy UI components

export const LazyLottie = React.lazy(() =>
  import('lottie-light-react').then((m) => ({ default: m.default })),
)

export const LazyReactMarkdown = React.lazy(() =>
  import('react-markdown').then((m) => ({ default: m.default })),
)

// Loading fallback component
export const LazyLoadingFallback: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`animate-pulse rounded bg-grey-100 ${className || 'h-32'}`} />
)

// Error boundary for lazy components
export class LazyErrorBoundary extends React.Component<
  { children: React.ReactNode; fallback?: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode; fallback?: React.ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Lazy component error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className='p-4 text-center text-neutral-500'>
            Failed to load component. Please refresh the page.
          </div>
        )
      )
    }

    return this.props.children
  }
}
